<template>
  <ZigzagServiceLayout
    mainTitle="Diverse Care Now Educación"
    mainDescription="Programas de capacitación integrales para iniciar tu carrera en el cuidado de la salud."
    :sections="sections"
    :hideBookButton="true"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'EducationContentEs',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'PROGRAMA DE FLEBOTOMÍA',
          title: 'Diploma de Técnico en Flebotomía',
          subtitle: '165 Horas de Capacitación Integral',
          paragraphs: [
            "Diverse Care Now Educación ofrece un programa integral de Diploma de Técnico en Flebotomía de 165 horas diseñado para proporcionar a los estudiantes los conocimientos, habilidades prácticas y capacitación práctica necesarios para la flebotomía.",
            "El programa combina instrucción en el aula con capacitación práctica supervisada, incluyendo técnicas de extracción de sangre, venopunción, punción capilar, manejo de muestras, control de infecciones, procedimientos de seguridad, identificación del paciente y estándares profesionales."
          ],
          list: [
            "Técnicas de extracción de sangre y venopunción",
            "Punción capilar y manejo de muestras",
            "Control de infecciones y procedimientos de seguridad",
            "Identificación del paciente y estándares profesionales"
          ],
          image: '/images/services/education-classroom.png'
        },
        {
          label: 'CERTIFICACIÓN',
          title: 'Preparación para Certificación AMCA',
          subtitle: 'Tu camino hacia una carrera gratificante en el cuidado de la salud.',
          paragraphs: [
            "Al completar exitosamente el programa de 165 horas, los estudiantes reciben un Diploma de Técnico en Flebotomía y están preparados para presentar el examen de certificación AMCA.",
            "Nuestro programa proporciona la base que necesitas para ingresar al campo laboral de la salud con confianza y competencia."
          ],
          list: [
            "Programa: Diploma de Técnico en Flebotomía",
            "Duración: 165 Horas",
            "Institución: Diverse Care Now Educación",
            "Capacitación: Aula y Habilidades Clínicas Prácticas",
            "Preparación para Certificación: Examen de Certificación de Flebotomía AMCA"
          ],
          image: '/images/services/education-certification.png'
        }
      ]
    };
  }
};
</script>
